'use client';
import { FunctionComponent, ReactNode } from 'react';

export interface ContactInfoItemProps
{
    icon: string;
    title: string;
    valueContent: ReactNode;
    className?: string;
}

/**
 * Component: displays a single contact information item with icon, title and content.
 */
const ContactInfoItem: FunctionComponent<ContactInfoItemProps> = (props) =>
{
    const { icon, title, valueContent } = props;

    /** Render */
    return (
        <div className={`contact-info-item d-flex ${props.className ?? ''}`}>
            <div className="pe-2">
                <i className={`${icon}`}></i>
            </div>
            <div className="flex-grow-1">
                <div className="contact-info-label mb-1">
                    <strong>{title}</strong>
                </div>
                <div className="contact-info-value">
                    {valueContent}
                </div>
            </div>
        </div>
    );
}

export default ContactInfoItem; 